import React from "react";
import IconDownload from "../iconComponents/IconDownload";
import { connect, useSelector } from "react-redux";
import DocStatusTag from "../common/DocStatusTag";
import { alertPermissionsRequired } from "../../actions/messages";
import { numberWithCommas } from "../common/Helpers";


export function ContractDetailsInfo(props) {
    const { downloadAttachment } = props;
    const project = useSelector((state) => state.projects.project);
    const contract = useSelector((state) => state.contract.contract);
    const invitations = useSelector((state) => state.contract.invitations);
    const user = useSelector( (state) => state.auth.user );
    const { contract_description, contract_name, contract_number, contract_value, contract_id, attachments } = contract;
    const attachmentsLength = attachments ? attachments.length : 0;
    // const userIsCreator = user.croles.Creator === true;
    // const userIsRep = user.email === contract.PCA.email || user.email == contract.VCA.email || contract.contract_status === "Draft";

    return (
        <>
            <div className="info-grid c-3">
                <div className="item firstcol">
                    <h3 className="content2 heavy-grey">Contract Description</h3>
                    <h4 className="content1 light-black" style={{whiteSpace: "break-spaces"}}>{contract_description ? contract_description : "-" }</h4>
                </div>
                <div className="item" >
                    <h3 className="content2 heavy-grey">Project</h3>
                    {invitations.length > 0
                    ?<h4 className="content1 light-black " >{contract.project_name ? contract.project_name : ""}</h4>
                    :<h4 className="content1 light-black link2" onClick={() => props.onLink(`/mng/project/view/${contract.project_id}`)} >{contract.project_name ? contract.project_name : ""}</h4>
                    }
                </div>
                <div className="item" >
                    <h3 className="content2 heavy-grey">Contract Status</h3>
                    <DocStatusTag status={contract.is_rejected ? "Rejected" : contract.contract_status} fontSize="content2" >
                        {contract.is_rejected ? "Rejected" : contract.contract_status}
                    </DocStatusTag>
                </div>
                <div className="item firstcol lastrow">
                    <h3 className="content2 heavy-grey">Documents</h3>
                    { attachmentsLength > 0 
                    ? <ul className="dropped">
                        {attachments.map((file) => {
                            return (                      
                                <li key={file.id}>
                                    <a onClick={() => downloadAttachment(file.id, file.file_name)}>
                                        <IconDownload className="iblock" height="13px" pathClass="p-fill" /> &nbsp; 
                                    </a>
                                    <p className="iblock content1 light-black">{file.file_name} </p>
                                </li>
                            );
                        })}
                    </ul>
                    : <p className="content1 light-black gap-below-s">-</p> 
                    }
                </div>
                <div className="item lastrow" >
                    <h3 className="content2 heavy-grey">Invoice Schedule</h3>
                    <h4 className="content1 light-black">{contract.duration_review ? "Review by day " + contract.duration_review : "" }</h4>
                    <h4 className="content1 light-black">{contract.duration_payment ? "Pay by day " + contract.duration_payment : "" }</h4>
                    <h4 className="content1 light-black">{(!contract.duration_payment && !contract.duration_review) && "No deadlines" }</h4>
                </div>
                <div className="item lastrow" >
                    <h3 className="content2 heavy-grey">Value</h3>
                    <h4 className="content1 light-black">{ contract.contract_value ? "$ " + numberWithCommas(contract.contract_value) : "" }</h4>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {alertPermissionsRequired})(ContractDetailsInfo);

// <Wizard className="gap-above-m gap-below-m" />
//                 <div className="info-grid c-4 r-4">
                
//                     <div className="item firstcol" style={{gridColumn: "1 / span 2"}}>
//                         <h3 className="content2 heavy-grey gap-below-xs">Action Required</h3>
//                         <InvoiceNextAction />
//                         { invoiceTakeAction() }
//                     </div>
//                     <div className="item"  style={{gridColumn: "3 / span 2"}}></div>
//                     <div className="item firstcol">
//                         <h3 className="content2 heavy-grey">Contract</h3>
//                         <h4 className="content1 light-black">{invoice.contract_number}</h4>
//                         <h5 className="content2 light-black" style={{whiteSpace: "break-spaces"}}>{invoice.contract_name}</h5>
//                     </div>